
import { Menu, X } from "lucide-react";

interface MobileNavButtonProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isScrolled?: boolean;
}

const MobileNavButton = ({ isOpen, setIsOpen, isScrolled = false }: MobileNavButtonProps) => {
  return (
    <div className="lg:hidden flex items-center">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`p-3 transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-md ${
          isScrolled ? "text-muted-foreground" : "text-foreground"
        }`}
        aria-label={isOpen ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
        aria-expanded={isOpen}
      >
        {isOpen ? <X size={24} aria-hidden="true" /> : <Menu size={24} aria-hidden="true" />}
      </button>
    </div>
  );
};

export default MobileNavButton;
